import { Controller } from "stimulus";

export default class extends Controller {
  
  get accountId() {
    return this.element.getAttribute('data-kanban-initial-load-account-id-value') || '';
  }

  get boardId() {
    return this.element.getAttribute('data-kanban-initial-load-board-id-value') || '';
  }

  get archived() {
    const value = this.element.getAttribute('data-kanban-initial-load-archived-value');
    return value === 'true';
  }

  get clientId() {
    return this.element.getAttribute('data-kanban-initial-load-client-id-value') || '';
  }

  get peopleId() {
    return this.element.getAttribute('data-kanban-initial-load-people-id-value') || '';
  }

  get query() {
    return this.element.getAttribute('data-kanban-initial-load-query-value') || '';
  }

  get projectTagId() {
    return this.element.getAttribute('data-kanban-initial-load-project-tag-id-value') || '';
  }

  connect() {
    setTimeout(() => {
      if (this.hasUnloadedLists()) {
        this.loadInitialProjects();
      }
    }, 100);
  }

  hasUnloadedLists() {
    const loadingElements = document.querySelectorAll('.kanban-loading');
    return loadingElements.length > 0;
  }

  loadInitialProjects() {
    const accountId = this.accountId;
    const boardId = this.boardId;
    
    if (!accountId || !boardId) {
      this.showErrorState();
      return;
    }

    const params = new URLSearchParams({
      ...(this.archived && { archived: 'true' }),
      ...(this.query && { q: this.query }),
      ...(this.clientId && { client_id: this.clientId }),
      ...(this.peopleId && { people_id: this.peopleId }),
      ...(this.projectTagId && { project_tag_id: this.projectTagId })
    });

    
    const pathSegments = window.location.pathname.split('/').filter(s => s);
    const knownLocales = ['nl', 'fr', 'de', 'zh', 'es', 'ja', 'it', 'pt', 'ko', 'ar'];
    const firstSegment = pathSegments[0];
    const locale = knownLocales.includes(firstSegment) ? firstSegment : '';
    const localePrefix = locale ? `/${locale}` : '';
    
    const url = `${localePrefix}/${accountId}/boards/${boardId}/load_initial_projects?${params.toString()}`;

    fetch(url, {
      headers: { 
        "X-Requested-With": "XMLHttpRequest",
        "Accept": "application/json"
      }
    })
      .then(res => {
        if (!res.ok) {
          return res.text().then(text => {
            let errorMessage = `HTTP error! status: ${res.status}`;
            try {
              const json = JSON.parse(text);
              errorMessage = json.error || errorMessage;
            } catch (e) {
              if (text) errorMessage = text.substring(0, 200);
            }
            throw new Error(errorMessage);
          });
        }
        return res.json();
      })
      .then(data => {
        if (data.error) {
          this.showErrorState();
          return;
        }
        
        if (data.projects && Object.keys(data.projects).length > 0) {
          this.renderProjects(data.projects);
          this.hideLoadingStates();
        } else {
          this.hideLoadingStates();
        }
      })
      .catch(error => {
        console.error("Error loading initial projects:", error);
        this.showErrorState();
      });
  }

  renderProjects(projectsByList) {
    Object.keys(projectsByList).forEach(listId => {
      const container = document.querySelector(`#kanban-list-items-${listId}`);
      if (container) {
        container.innerHTML = projectsByList[listId];
        
        const kanbanListElement = container.closest('.kanbanlist[data-controller*="infinite-scroll"]');
        if (kanbanListElement) {
          const projectsCount = parseInt(kanbanListElement.dataset.projectsCount || '0', 10);
          const event = new CustomEvent('projects-loaded', {
            detail: { listId, projectsCount }
          });
          kanbanListElement.dispatchEvent(event);
        }
      }
    });
  }

  hideLoadingStates() {
    document.querySelectorAll('.kanban-loading').forEach(el => {
      el.remove();
    });
  }

  showErrorState() {
    document.querySelectorAll('.kanban-loading').forEach(el => {
      el.innerHTML = '<p class="error">Failed to load projects. Please refresh the page.</p>';
    });
  }

}

